document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('predictive-search').forEach((search) => search.close?.());
  document.querySelectorAll('.pg-catalog-menu[open]').forEach((menu) => { menu.removeAttribute('open'); (menu.pgReturnFocus || document.querySelector('[data-pg-menu-open]') || menu.querySelector('summary'))?.focus(); });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.pg-catalog-menu[open]').forEach((menu) => { if (!menu.contains(event.target) && !event.target.closest('[data-pg-menu-open]')) menu.removeAttribute('open'); });
});
